import { render, staticRenderFns } from "./Wording.vue?vue&type=template&id=3dd0f5b4&scoped=true"
import script from "./Wording.vue?vue&type=script&lang=js"
export * from "./Wording.vue?vue&type=script&lang=js"
import style0 from "./Wording.vue?vue&type=style&index=0&id=3dd0f5b4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd0f5b4",
  null
  
)

export default component.exports